module.exports = __webpack_public_path__ + "static/media/bhaowal.e7ae12ab.jpg";